import React, { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Clock } from 'lucide-react';

export const DelayNode = memo(({ data, isConnectable }: NodeProps) => {
  const duration = (data?.config as any)?.duration;
  const unit = (data?.config as any)?.unit || 'days';
  
  return (
    <div className="bg-white border-2 border-orange-200 rounded-lg shadow-sm min-w-[200px] hover:border-orange-500 transition-colors">
      <Handle
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-orange-500 border-2 border-white"
      />
      <div className="bg-orange-50 border-b border-orange-100 p-2 rounded-t-md flex items-center gap-2">
        <div className="bg-orange-600 text-white p-1 rounded">
          <Clock className="h-3 w-3" />
        </div>
        <div className="flex flex-col">
          <div className="text-sm font-semibold text-gray-900">Delay</div>
          {data?.label && (
            <div className="text-xs text-gray-500 font-medium">
              {data.label as string}
            </div>
          )}
        </div>
      </div>
      <div className="p-3">
        <div className="text-xs font-medium text-orange-700 bg-orange-50 inline-block px-2 py-1 rounded">
          {duration ? `Wait ${duration} ${unit}` : 'Not configured'}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        className="w-3 h-3 bg-orange-500 border-2 border-white"
      />
    </div>
  );
});

DelayNode.displayName = 'DelayNode';
